import appMain from './appMain.vue'

export default appMain
